import { toast } from 'sonner';
import { NotFoundError } from './NotFoundError';
import Auth0Client from '../auth/auth0Client';

export default class Fetch {
  public static async json<T>(url: string, options?: RequestInit): Promise<T> {
    try {
      const accessToken = await Auth0Client.getInstance().getAccessToken();

      options = {
        ...options,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...options?.headers,
        },
      };

      return fetch(url, options)
        .then(async (response) => {
          if (response.status === 401) {
            toast.error('Your session has expired. Please log in again.');
          }
          if (response.status === 404) {
            throw new NotFoundError();
          }

          if (!response.ok) {
            await response.json().then((data) => {
              throw new Error(
                data.message || 'An error occurred while fetching data',
              );
            });
          }

          return response.json() as T;
        })
        .catch((error) => {
          throw error;
        });
    } catch (error) {
      console.error('Fetch error:', error);
      toast.error('Authentication error. Please log in.');
      throw error;
    }
  }
}
